package com.example.mystybag.notificationsUtils.expected

import dev.icerock.moko.resources.ImageResource
import com.example.mystybag.common.model.NotificationConfigModel
import com.example.mystybag.common.model.ShowNotificationVisualModel
import com.example.mystybag.notificationsUtils.model.BaseMessageModel
import com.example.mystybag.sharedmodels.SCImage

actual object NotificationHelper {
    actual fun showNotification(
        model: ShowNotificationVisualModel,
        data: BaseMessageModel,
        configModel: NotificationConfigModel
    ) {}

    actual fun setNotificationImage(
        defaultIcon: ImageResource,
        defaultContactIcon: ImageResource
    ): SCImage? = null

    actual fun setNotificationTitle(phone: String): String = phone

    actual fun setNotificationRingtone(
        ringtoneId: Int,
        ringtone: String,
        systemChannelId: String
    ): String = ringtone

    actual fun setNotificationChannels() {}
}
